import React from 'react';
import { TabHeaders } from '../constants';
import { default as Online } from './Online';
import { default as InPrintForm } from './Inprint';
import { default as OnlineDatabaseForm } from './OnlineDatabase';
export var getTabList = function getTabList(activeTabIndex) {
  return [{
    header: TabHeaders.IN_PRINT,
    panel: activeTabIndex === 0 ? /*#__PURE__*/React.createElement(InPrintForm, null) : /*#__PURE__*/React.createElement(React.Fragment, null)
  }, {
    header: TabHeaders.ONLINE,
    panel: activeTabIndex === 1 ? /*#__PURE__*/React.createElement(Online, null) : /*#__PURE__*/React.createElement(React.Fragment, null)
  }, {
    header: TabHeaders.ONLINE_DATABASE,
    panel: activeTabIndex === 2 ? /*#__PURE__*/React.createElement(OnlineDatabaseForm, null) : /*#__PURE__*/React.createElement(React.Fragment, null)
  }];
};